import Component from '../core/Component'
import Scroll from '../services/Scroll'

export const defaults = {
    threshold: 300,
}

export const STATES = {
    COLLAPSED: 'is-collapsed',
}

export default class ContentReveal extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            toggle: null,
            target: null,
        }

        const threshold = parseInt(this.element.dataset.threshold)

        if (!isNaN(threshold)) {
            this.options.threshold = threshold
        }
    }

    prepare() {
        this.ref.toggle.addEventListener('click', this.handleClick)
        this.refresh()
    }

    destroy() {
        this.ref.toggle.removeEventListener('click', this.handleClick)
    }

    handleClick = (event) => {
        event.preventDefault()
        this.toggle()
    }

    refresh() {
        if (this.ref.target.scrollHeight > this.options.threshold) {
            this.collapse()
        } else {
            this.expand()
        }
    }

    toggle() {
        if (this.is(STATES.COLLAPSED)) {
            this.expand()
        } else {
            this.collapse()
        }
    }

    collapse() {
        this.element.classList.add(STATES.COLLAPSED)
    }

    expand() {
        this.element.classList.remove(STATES.COLLAPSED)
    }
}
